import type { ReactNode } from 'react';
import { MarketingHeader, FooterSection } from '@/pages/landing';

type MarketingShellProps = {
  children: ReactNode;
  /** Carries niche attribution onto the header's "Start free" CTA. */
  ctaSearch?: Record<string, string>;
};

export function MarketingShell({ children, ctaSearch }: MarketingShellProps) {
  return (
    <div className="min-h-screen overflow-x-hidden bg-canvas font-sans text-canvas-fg antialiased">
      <MarketingHeader signupSearch={ctaSearch} solid />
      <main className="pt-[4.5rem] md:pt-20">{children}</main>
      <FooterSection />
    </div>
  );
}
